import { Tooltip } from "bootstrap";
import { useEffect } from "react";

function StackItem({ style, src, handleStyleImg, stack }) {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) =>
        new Tooltip(tooltipTriggerEl, {
          customClass: "customTooltip",
        })
    );

    // Cleanup function to destroy tooltips
    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, []);
  return (
    <div
      className={`p-0 item-img ${
        handleStyleImg.hoveredIndex !== null
          ? handleStyleImg.index === handleStyleImg.hoveredIndex
            ? ""
            : "not-hovered"
          : ""
      }`}
      style={style.box}
      onMouseEnter={() => handleStyleImg.handleMouseEnter(handleStyleImg.index)}
      onMouseLeave={() => handleStyleImg.handleMouseLeave()}
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      data-bs-title={`${stack[0]} - ${stack[1]}`}
    >
      <img loading="lazy" style={style.img} src={src} alt="" />
    </div>
  );
}

export default StackItem;
